export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12056.fdf81fca.jpg";